import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import { fixPropWarnings } from '../../utils/fixPropWarnings';

interface MobileButtonContainerProps {
  btnpos?: string;
}

const MobileButtonContainer = styled.div.withConfig(fixPropWarnings('btnpos'))<MobileButtonContainerProps>`
  width: 100%;
  height: 70px;
  position: fixed;
  bottom: 0;
  background-color: ${themeGet('colors.greys.0')};
  z-index: 999;
  display: none;
  align-items: center;
  padding: 0 1rem;

  &[btnpos='Center'] {
    justify-content: center;
  }
  &[btnpos='Left'] {
    justify-content: flex-start;
  }
  &[btnpos='Right'] {
    justify-content: flex-end;
  }

  &.mobile-quote-enter {
    bottom: -75px;
  }
  &.mobile-quote-enter-done {
    bottom: 0;
    transition: bottom 300ms;
  }
  &.mobile-quote-exit {
    bottom: 0;
  }
  &.mobile-quote-exit-active {
    bottom: -70px;
    transition: bottom 700ms;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    display: flex;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: none;
  }
`;

export default MobileButtonContainer;
